import React from 'react';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import { LoginImageComponent } from 'ComponentsTypes';
import { makeStyles } from '@material-ui/styles';
import styles from './styles';
import ChangeLanguage from 'components/ChangeLanguage';

const useStyles = makeStyles(styles);

const UserLoginImageContainer: React.FC<LoginImageComponent> = ({
  width,
  header,
  description,
  imageColor,
  bgImage,
  cover,
  config,
  isMfaPage,
}) => {
  const classes = useStyles({ imageColor, bgImage, cover });
  const isMobile = isWidthDown('md', width, true);

  return (
    <Grid
      container
      className={classes.imageContainer}
      alignContent={isMobile ? undefined : 'center'}
    >
      {isMobile && (
        <Grid container style={{ marginLeft: -50 }}>
          <ChangeLanguage />
        </Grid>
      )}
      <Grid
        item
        xs={12}
        justifyContent="center"
        alignItems="center"
        alignContent="center"
        className={classes.welcomeMessage}
      >
        {typeof header === 'string' ? (
          <Typography
            variant="h1"
            style={{
              fontSize: isMfaPage ? config?.headerMfaFontSize : config?.headerLoginFontSize,
              fontWeight: 900,
              color: 'white',
              fontFamily: 'Roboto',
              textShadow: '0px 3px 6px #00000029',
              wordBreak: 'break-word',
            }}
          >
            {header}
          </Typography>
        ) : (
          header
        )}
      </Grid>
      <Grid
        justifyContent="center"
        item
        xs={12}
        className={classes.imageWrapper}
      >
        <Grid item xs={12} lg={7}>
          <Typography
            variant="subtitle1"
            className={classes.subtitle}
            style={{ fontSize: isMfaPage ? config?.descriptionMfaFontSize : config?.descriptionLoginFontSize }}
          >
            {description}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = ({ config }) => ({ config });

export default withWidth()(connect(mapStateToProps)(UserLoginImageContainer));
